import { render, staticRenderFns } from "./CreateUserNurse.vue?vue&type=template&id=013bb464&"
import script from "./CreateUserNurse.vue?vue&type=script&lang=js&"
export * from "./CreateUserNurse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports